import { DocumentUpdate } from '../../document/models/request'
import createDocumentDeleter from '../../document/components/createDocumentDeleter'

interface DeleteConsignmentDocumentsProps {
  documentsToDelete: DocumentUpdate[]
}

export default function useDeleteConsignmentDocuments() {
  const deleteConsignmentDocuments = async ({ documentsToDelete }: DeleteConsignmentDocumentsProps) => {
    const deleteDocuments = createDocumentDeleter()
    return deleteDocuments(documentsToDelete)
  }

  return { deleteConsignmentDocuments }
}
